import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
	name: 'syncStatusTranslate',
	pure: false,
})
export class SyncStatusTranslatePipe implements PipeTransform {
	constructor(private translateService: TranslateService) {}

	transform(value: string): string {
		return this.translateService.instant(`administration.sync-monitoring.statuses.${value}`);
	}
}
